// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#personalCenter .el-loading-spinner{margin-top:-10px}#personalCenter .el-loading-spinner .circular{width:20px;height:20px}", ""]);
// Exports
module.exports = exports;
